<mat-card appearance="outlined" class="attribs_card" [ngClass]="{ outline: appearance() === 'outline' }">
  <mat-card-header>
    <mat-card-title>
      <img class="image" src="//www.cdnstyles.com/static/images/source-icons/Google.svg" alt="Google" />
      <span class>Google</span>
    </mat-card-title>
  </mat-card-header>

  @if (fullAttributes().length && categoryLength() > 0) {
    <mat-card-content class="attrib_card_content">
      <glxy-form-field class="form-field">
        <glxy-label>
          <span>{{ 'FRONTEND.FORMS.ATTRIBUTES.AUTOCOMPLETE_HEADER' | translate }}</span>
        </glxy-label>
        <input
          [formControl]="autocompleteControl"
          type="text"
          placeholder="{{ 'FRONTEND.FORMS.ATTRIBUTES.MORE_ATTRIBUTES' | translate }}"
          matInput
          class="attrib_card_content-input"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="autoCompleteDisplayFn"
          (optionSelected)="onOptionSelected($event)"
        >
          @for (attribute of filteredAttributes(); track attribute) {
            @if (attribute.value === null) {
              <mat-option [value]="attribute.name">
                {{ attribute.displayName }}
              </mat-option>
            }
          }
        </mat-autocomplete>
      </glxy-form-field>
      <forms-attributes-input
        [form]="form()"
        [orderedInputAttributes]="orderedInputAttributes()"
        (cleared)="clearAttribute($event)"
      ></forms-attributes-input>
    </mat-card-content>
  } @else {
    <div class="empty-attributes-image">
      <span>
        <img
          src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/listing-profile-attributes-empty.svg"
          alt="Empty Attributes"
        />
      </span>
      @if (categoryLength() < 1) {
        <div>
          <span (click)="showLocationTab()">{{
            'FRONTEND.FORMS.ATTRIBUTES.SELECT_BUSINESS_CATEGORY' | translate
          }}</span>
          <span>{{ ' ' }}</span>
          <span>{{ 'FRONTEND.FORMS.ATTRIBUTES.TO_ACCESS_ATTRIBUTES' | translate }}</span>
        </div>
      }
    </div>
  }
</mat-card>
